import React, { Component } from 'react';
import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { setCurrent } from '../actions'
import { push } from 'react-router-redux'
import { Player } from 'video-react'
import Listproject from './listproject'

class Singleproject extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ready: false,
      dark: true
    }
  }

  shouldComponentUpdate(nextProp, nextState) {
    // debugger;
    var difPath = this.props.match.params.proj !== nextProp.match.params.proj;
    var difCurrent = this.props.current.path !== nextProp.current.path;
    var difState = this.state !== nextState;
    return difPath || difCurrent || difState;
  }

  componentWillMount() {
    window.scrollTo({top: 0});
    // window.jQuery('html, body').animate({scrollTop: 0})
    let projPath = this.props.match.params.proj;
    document.body.style.backgroundColor = this.props.current.bgcolor;
    if (this.props.current.path !== projPath) {
      this.props.setCurrent(projPath);
    }
  }

  componentWillUpdate(nextProp) {
    window.scrollTo({top: 0});
    // window.jQuery('html, body').animate({scrollTop: 0})
    this.props.setCurrent(nextProp.match.params.proj)
  }

  componentDidUpdate() {
    document.body.style.backgroundColor = this.props.current.bgcolor;
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = '#fff';
  }

  revealProject() {
    setTimeout(()=>{
      this.setState({
        dark: false
      })
    }, 500);
  }

  displayRelated() {
    var cat = this.props.current.category;
    var path = this.props.current.path;
    var relatedProjs = this.props.projects.filter(proj=>proj.category === cat && proj.path !== path).slice(0,4);

    if (relatedProjs.length < 4) {
      var numPlaceholders = 4-relatedProjs.length;
      for (var i = 0; i < numPlaceholders; i++) {
        relatedProjs.push('placeholder');
      }
    }
    var grey = ['#F8F8F8','#F5F5F5','#F0F0F0','#E8E8E8','#E0E0E0','#DCDCDC','#D8D8D8','#D3D3D3'];

    return relatedProjs.map((proj, index)=> {
      if (proj === 'placeholder') {
        return <div className="placeholder"></div>
      }
      return <Listproject
        truncate="55"
        greyBg={grey[index]}
        index={index}
        history={this.props.history}
        project={proj}
        />
    })
  }

  render() {
    let {name, video, stack, photos, links, date, bgcolor, mainphoto, long_desc, category} = this.props.current

    let styleSingle = {
      backgroundColor: bgcolor
    }

    let styleVideo = {
      opacity: this.state.dark ? 0:1
    }

    return (
        <div className="single-proj" style={styleSingle}>
          <div className="proj__video" style={styleVideo}>
            <Player src={video}
              autoPlay/>
          </div>
          <img src={mainphoto}
            onLoad={this.revealProject.bind(this)}
            style={{display: 'none'}}
            alt="load-test" />
          <div className="proj__main">
            <div className="proj__details">
              <h1>{name}</h1>
            </div>
            <div className="proj__details proj__info">
              <div className="details_left">
                <p><strong>Date completed:</strong> {date}</p>
                <p><strong>Stack:</strong> {!!stack ? stack.join(', '):null}</p>
                <p><strong>Links:</strong> {!!links ? links.map((link)=>{
                  return (<a href={link.val} target="_blank">{link.name}</a>)
                }):null}</p>
              </div>
              <div className="details_right">
                {!!long_desc ? long_desc.split("\n\n").map((par)=> {
                  return <p>{par}</p>
                }): null}
              </div>
            </div>
            {!!photos ? <div className="separator"></div> : null}
            <div className="proj__list">

              {!!photos ? photos.map((photo, index)=> {
                return (
                  <div>
                    <img src={photo.url} alt={photo.desc}/>
                    <p>{photo.desc}</p>
                  </div>
                )
              }):null}
            </div>
            <div className="proj__related desktop-only">
              <h2>Related {category}</h2>
              <div className="proj__related-projs">
                {this.displayRelated()}
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    current: state.current,
    projects: state.projects
  })
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setCurrent, push
  }, dispatch)
}

const ConnectedSingleproject = connect(mapStateToProps, mapDispatchToProps)(Singleproject)

export default ConnectedSingleproject



// WEBPACK FOOTER //
// ./src/components/singleproject.js